enum Attachment {
  SET_ATTACHMENT_INITIALIZE = 'SET_ATTACHMENT_INITIALIZE',
  SET_ATTACHMENT_LIST = 'SET_ATTACHMENT_LIST',
  CLEAR_ATTACHMENT_LIST = 'CLEAR_ATTACHMENT_LIST'
}

export default Attachment;
